module.exports = __webpack_public_path__ + "static/media/focus3.3fd2ce3c.jpg";